export default {
    columnList: {
        buttonTitle: 'Selecting list columns',
        okTitle: 'Save',
        cancelTitle: 'Cancel',
        modalTitle: 'Select the required columns',
    },

    eventFilter: {
        orderId: 'Order number',
        eventHandlersPlaceholder: 'Types of events',
        eventHandlersText: 'Event types selected',
        dateCreate: 'Date of creation',
        buttonClear: 'Clear filter',
    },

    filter: {
        id: 'Order number',

        orderSourceTypes: {
            placeholder: 'Order source',
            text: 'Order sources selected',
        },

        timeWaitingFrom: 'Waiting period: from',
        timeWaitingTo: 'Waiting period: up to',
        buttonClear: 'Clear filter',
        search: 'Name or phone number of the client',
        buttonClearSearch: 'Clear search',
        dateCreateFrom: 'Date of creation: from',
        dateCreateTo: 'Date of creation: before',

        statuses: {
            placeholder: 'Processing status',
            text: 'Selected statuses',
        },

        userAuthorization: {
            placeholder: 'User status',
            text: 'User statuses selected',
        },

        pfm: 'PFM Store Code',
        city: 'Locality',
        address: 'Store address',
        formSelectOption: 'Test order',

        managers: {
            placeholder: 'Manager',
            text: 'Managers selected',
        },

        deliveryStatuses: {
            placeholder: 'Delivery status',
            text: 'Delivery statuses selected',
        },

        payTypes: {
            placeholder: 'Payment type',
            text: 'Payment types selected',
        },

        payStatuses: {
            placeholder: 'Payment status',
            text: 'Selected payment statuses',
        },

        deliveryServiceTypes: {
            placeholder: 'Type of delivery',
            text: 'Selected delivery types',
        },

        orderTypes: {
            placeholder: 'Order type',
            text: 'Selected order types',
        },

        subscriptionTypes: {
            placeholder: 'Subscription type',
            text: 'Selected subscription types',
        },

        deliveryServiceMethods: {
            placeholder: 'Delivery method',
            text: 'Selected delivery methods',
        },

        testValues: {
            value1: 'No',
            value2: 'Yes',
        },

        userAuthorizationOptions: {
            value1: 'Authorized',
            value2: 'Not authorized',
        },

        partnerOrderId: "№ partner's order",
    },

    productFilter: {
        input: 'Search',
        checkbox: ['LK', 'Barcode'],
    },
};